export default __webpack_public_path__ + "safari-pinned-tab.d3a8afe107fc60e413110b439fd92dc6.svg";